var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaderboards"},[_c('LeaderboardTeams',{attrs:{"all":true,"title":'Alle Teams'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }